export default __webpack_public_path__ + "static/Learn Chinese Effectively-ba51a593defacd4a800615c1741cc64f.jpg";